export const SELECT_CHANGE_ACTION = {
    CLEAR: 'clear',
    POP_VALUE: 'pop-value',
    REMOVE_VALUE: 'remove-value',
};
